import React from 'react';
import {observer} from 'mobx-react';
import './HelpSection.scss';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import { ReactComponent as ExternalLinkIcon } from '../../../assets/icons/external-link.svg';

const HelpSection: any = observer(() => {
    return (
        <div className="HelpSection">
            <div className="InfoIcon">
                <InfoIcon/>
            </div>
            <div className="InfoText">
                <div>Looking for some help? <a href="https://discord.gg/AhD4BJHZD8" target="_blank" rel="noopener noreferrer">Join our Discord <ExternalLinkIcon className="external-link-icon"/></a></div>
                <div>To get LP tokens use the following pools:</div>
                <a href="https://aerodrome.finance/deposit?pool=0x5cb6e1eab61a4c228dee712faa2d1c9c3db3bf81&token0=0x6C672C3612F6B8AD686516B7657F61610F4943ab&token1=0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913&chain0=8453&chain1=8453" target="_blank" rel="noopener noreferrer">Aerodrome NXUSD-USDC Pool <ExternalLinkIcon className="external-link-icon"/></a>
                <a href="https://aerodrome.finance/deposit?pool=0x007c90677ff52c7f7da49711fbd5277ed62ebe8d&token0=0x365b481Bc61240AaA261EE637c9d2F9c1735EF3e&token1=0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913&chain0=8453&chain1=8453" target="_blank" rel="noopener noreferrer">Aerodrome NRS-USDC Pool <ExternalLinkIcon className="external-link-icon"/></a>
            </div>
        </div>
    );
});

export default HelpSection;
